export const getApiDomain = (): string => {
  return process.env.REACT_APP_API_DOMAIN || '';
};

export const getFeedbackApiDomain = (): string => {
  return process.env.REACT_APP_FEEDBACK_DOMAIN || '';
};
